var React = require('react');

function AsanaHalfTortoise (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeMiterlimit":"10","d":"M10.063,21C9.188,21,4,21,4,21s-3-0.802-3-4.011\n\tC1,13.596,4.07,11,9.583,11c6.208,0,9.727,3.212,13.193,6c4.971,4,9.995,8,15.224,8 M6,17c0,0,3.917,0,5,0c2.391,0,4,1.657,4,4\n\tc0,1.978-1.306,4-4,4c-2.556,0-9.063,0-9.063,0L4,21 M17,20v5c0,0,5.374,0,6,0c2.209,0,4-1.791,4-4c0-0.694,0-0.694,0-0.694"}));
}

AsanaHalfTortoise.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"38px","height":"38px","viewBox":"0 0 38 38","enableBackground":"new 0 0 38 38","xmlSpace":"preserve"};

module.exports = AsanaHalfTortoise;

AsanaHalfTortoise.default = AsanaHalfTortoise;
